import { Tag, type TagVariant } from "@/components/ui/tag";

const VARIANTS: Record<string, TagVariant> = {
  // runs
  running: "info",
  cancelling: "warning",
  halting: "warning",
  pausing: "warning",
  paused: "warning",
  completed: "success",
  cancelled: "muted",
  halted: "destructive",
  // numbers
  pending: "muted",
  ok: "success",
  failed: "destructive",
  // verification
  accepted: "success",
  rejected: "destructive",
  unknown: "muted",
  // users
  active: "success",
  inactive: "muted",
};

const LABELS: Record<string, string> = {
  ok: "registered",
  halting: "stopping",
  cancelling: "cancelling",
};

/** A run's, number's or account's state as the mini app's status tag. */
export default function StatusTag({ state, label }: { state: string; label?: string }) {
  return <Tag variant={VARIANTS[state] ?? "muted"}>{label ?? LABELS[state] ?? state}</Tag>;
}
